<template>
  <div>
    <b-modal ref="photoModal" title="查看照片" size="lg" hide-footer>
      <img :src="photoUrl" style="width: 100%;" alt="">
      <b-button variant="primary" class="mt-3" block @click="hidePhotoModal">确定</b-button>
    </b-modal>
    <b-row>
      <b-col cols="1">时间段：</b-col>
      <b-col>
        <b-form-datepicker v-model="startDate" v-bind="datePickerLocaleLabels" class="mb-1"
                           @input="fetchAlarm()"></b-form-datepicker>
        <b-form-timepicker show-seconds v-model="startDayTime" :hour12="false" v-bind="timePickerLocaleLabels"
                           @input="fetchAlarm()"></b-form-timepicker>
      </b-col>
      <b-col cols="1" style="text-align: center; align-self: center; font-size: 2em">
        至
      </b-col>
      <b-col>
        <b-form-datepicker class="mb-1" v-model="endDate" v-bind="datePickerLocaleLabels" @input="fetchAlarm()">
        </b-form-datepicker>
        <b-form-timepicker show-seconds v-model="endDayTime" :hour12="false" v-bind="timePickerLocaleLabels"
                           @input="fetchAlarm()">
        </b-form-timepicker>
        <div @change="checkTime()">
          <b-form-checkbox
              id="checkbox-1"
              v-model="checktime"
              name="checkbox-1"
              value="true"
              unchecked-value="false"
          >当前时间 <span style="color: grey">（间隔20秒）</span>
          </b-form-checkbox>
        </div>


      </b-col>

      <b-col>
        <p>道口名称：</p>
        <b-form-select v-model="stationName" :options="stationOptions" @change="handleChange"></b-form-select>
      </b-col>


      <b-col>
        <p>是否有人：</p>
        <b-form-select v-model="personPresent" :options="personOptions" @change="handleChange"></b-form-select>
      </b-col>
    </b-row>
    <hr/>

    <b-table class="mt-4" striped hover :items="items" :fields="fields" empty-text="没有查询到照片信息" show-empty>
      <template #cell(person)="data">
        {{ data.item.person === true ? '是' : '否' }}
      </template>
      <template #cell(imageType)="data">
        {{ data.item.imageType === true ? '自动拍照' : '相机触发' }}
      </template>
      <template #cell(photo_file)="data">
        <b-button variant="primary" @click="viewPhoto(data.item.device_code, data.item.photo_file)">
          照片
        </b-button>
      </template>
    </b-table>
    <b-pagination
        v-model="page"
        :total-rows="total"
        :per-page="pageSize"
        align="center"
        show-total
        @change="handlePageChange"
    ></b-pagination>

  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'

export default {
  props: {
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isSelected(newVal) {
      if (newVal === false) {
        clearInterval(this.interval);
      }
      else {
        this.checkTime()
        this.fetchStationNameList()
      }
    }
  },
  data() {
    return {
      deviceName: '',
      boo: true,
      startDate: null,
      endDate: null,
      startDayTime: null,
      endDayTime: null,
      stationName: null,
      page: 1,
      pageSize: 10,
      total: null,
      photoUrl: '',
      stationOptions: [
        { value: null, text: '选择道口名称' },
      ],
      personPresent: null,
      personOptions: [
        { value: null, text: '选择是否有人' },
        { value: true, text: '是' },
        { value: false, text: '否' }
      ],
      datePickerLocaleLabels: {
        weekdayHeaderFormat: 'narrow',
        labelPrevDecade: '过去十年',
        labelPrevYear: '上一年',
        labelPrevMonth: '上个月',
        labelCurrentMonth: '当前月份',
        labelNextMonth: '下个月',
        labelNextYear: '明年',
        labelNextDecade: '下一个十年',
        labelToday: '今天',
        labelSelected: '选择日期',
        labelNoDateSelected: '未选择日期',
        labelCalendar: '日历',
        labelNav: '日历导航',
        labelHelp: '使用光标键浏览日期'
      },
      timePickerLocaleLabels: {
        labelHours: '小时',
        labelMinutes: '分钟',
        labelSeconds: '秒',
        labelAmpm: '上下午',
        labelAm: '上午',
        labelPm: '下午',
        labelIncrement: '增加',
        labelDecrement: '减少',
        labelSelected: '选择时间',
        labelNoTimeSelected: '未选择时间',
        labelCloseButton: '关闭'
      },
      fields: [
        {key: 'index', label: '序号'},
        {key: 'line_work', label: '位置'},
        {key: 'station_name', label: '道口'},
        {key: 'alarm_time', label: '推送时间'},
        {key: 'imageType', label: '照片类型'},
        {key: 'person', label: '是否有人'},
        {key: 'photo_file', label: '照片'},
      ],
      items: [],
      checktime: '',
    }
  },
  computed: {
    startTime() {
      return `${this.startDate} ${this.startDayTime}`
    },
    endTime() {
      return `${this.endDate} ${this.endDayTime}`
    },
  },
  methods: {
    handleChange() {
      this.page = 1;
      this.fetchAlarm();
    },
    formatAlarmTime(alarmTimeData) {
      const year = alarmTimeData.date.year;
      const month = alarmTimeData.date.month.toString().padStart(2, '0');
      const day = alarmTimeData.date.day.toString().padStart(2, '0');
      const hour = alarmTimeData.time.hour.toString().padStart(2, '0');
      const minute = alarmTimeData.time.minute.toString().padStart(2, '0');
      const second = alarmTimeData.time.second.toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },

    fetchAlarm() {
      axios.get(`${this.$apiRoot}/image/list`, {
        params: {
          start: this.startTime,
          end: this.endTime,
          name: this.stationName,
          personPresent: this.personPresent,
          page: this.page,
          pageSize: this.pageSize
        }
      })
          .then((response) => {
            this.items = response.data.data.imageInfoDTOS;
            if (this.items.length > 0) {
              for (let i = 0; i < this.items.length; i++) {
                this.items[i]['index'] = i + 1;
                this.items[i].alarm_time = this.formatAlarmTime(this.items[i].alarm_time);
              }
            }
            this.total = response.data.data.total;
          });
    },
    fetchStationNameList() {
      axios.get(`${this.$apiRoot}/image/stationNames`)
          .then((response) => {
            const stationNames = response.data.data;
            this.stationOptions = [{ value: null, text: '选择道口名称' }];
            stationNames.forEach(name => {
              this.stationOptions.push({ value: name, text: name });
            });
          });
    },
    checkTime() {
      if (this.checktime === 'true') {

        this.startDate = moment().add({ days: -1 }).format('YYYY-MM-DD')
        this.startDayTime = moment().add({ days: -1 }).format('HH:mm:ss')
        this.endDate = moment().format('YYYY-MM-DD')
        this.endDayTime = moment().format('HH:mm:ss');
        this.fetchAlarm()

        clearInterval(this.interval);

        this.interval = setInterval(() => {
          this.endDate = moment().format('YYYY-MM-DD')
          this.endDayTime = moment().format('HH:mm:ss');
          this.fetchAlarm()
        }, 20000);
      } else {
        clearInterval(this.interval);
      }
    },

    hidePhotoModal() {
      this.$refs.photoModal.hide();
    },
    viewPhoto(deviceCode,photoFile) {
      this.photoUrl = `${this.$apiRoot}/deviceSim/img/${deviceCode}/${photoFile}.jpg`;
      this.$refs.photoModal.show();
    },

    handlePageChange(newPage) {
      this.page = newPage;
      this.fetchAlarm();
    },
  },
  mounted() {
    this.startDate = moment().add({days: -1}).format('YYYY-MM-DD')
    this.startDayTime = moment().add({days: -1}).format('HH:mm:ss')
    this.endDate = moment().format('YYYY-MM-DD')
    this.endDayTime = moment().format('HH:mm:ss');
    this.fetchAlarm()
  }
}
</script>
<style scoped>
</style>